
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends Vue {}
